import React from "react";
import "./AccountSecurityLayouComponent.scss";
import logo from "@resources/images/conceiveAbilities-logo.svg";
import rightBg from "@resources/images/security-bg.jpg";
import Constants from "@helper/Constants";
import Footer from "../Footer/Footer";

function AccountSecurityLayoutComponent({ children }) {
    const handleLogoClick = () => {
        window.open(Constants.PORTAL_URL, "_blank", "noopener,noreferrer");
    };

    return (
        <div className="row security">
            <div className="column left-column">
                <header>
                    <img src={logo} className="app-logo" alt="ConceiveAbilities" onClick={handleLogoClick} />
                </header>
                <div className="security-form">{children}</div>
                <Footer halfWidth isVisible />
            </div>
            <div className="column right-column" tabIndex="0">
                <img src={rightBg} alt="" className="security-right-image" />
            </div>
        </div>
    );
}

export default AccountSecurityLayoutComponent;
